import React, { useRef } from "react";
import {
  useMediaQuery,
  Box,
  Grid,
  Typography,
  IconButton,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const LandingPage = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const carouselRef = useRef(null); // Ref for touch event handling

  const images = [
    "/premium (1).jpg",
    "/premium (2).jpg",
    "/premium (3).jpg",
    "/premium (4).jpg",
    "/premium (5).jpg",
    "/premium (6).jpg",
    "/premium (7).jpg",
    "/premium (8).jpg",
    "/premium (9).jpg",
    "/premium (10).jpg",
    "/premium (11).jpg",
    "/premium (12).jpg",
  ];

  const icons = [
    "/image1.png",
    "/image2.png",
    "/image3.png",
    "/image4.png",
    "/image5.png",
    "/image6.png",
  ];

  const settings = {
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    swipeToSlide: false,
    touchThreshold: 20,
    draggable: false,
  };

  // Touch event handlers to prevent page scrolling
  const handleTouchMove = (e) => {
    const touch = e.touches[0];
    const carousel = carouselRef.current;

    if (carousel && carousel.contains(touch.target)) {
      e.preventDefault(); // Prevent vertical page scrolling
    }
  };

  return (
    <Box>
      <Box sx={{ height: "70vh" }}>
        <img
          src="/banner.png"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "22%",
            left: "50%",
            transform: "translateX(-50%)",
            textAlign: "center",
            color: "#fff",
            width: "100%",
          }}
        >
          <Typography variant="h6" textTransform="uppercase" mb={3}>
            {isMobile ? (
              <>
                Your Brand. <br />
                Our Craftsmanship. Your Hat.
              </>
            ) : (
              "Your Brand. Our Craftsmanship. Your Hat."
            )}
          </Typography>

          <Typography
            variant={isMobile ? "h4" : "h3"}
            width={isMobile ? "100%" : "45%"}
            margin="0 auto"
            fontWeight="bold"
          >
            We Craft Headwear That Highlights
            {isMobile && <br />}
            <span style={{ color: "#A3D4FF" }}> Your Brand </span>
          </Typography>
        </Box>
      </Box>

      {/* Premium Quality Section */}
      <Box
        sx={{
          pb: isMobile ? 5 : 10,
          pt: 5,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#E8F1FB",
          overflow: "hidden",
        }}
      >
        <Typography variant="h5" textAlign="center" fontWeight="bold" pb={5}>
          Premium Quality
        </Typography>
        {isMobile ? (
          // Carousel for mobile devices (1 image at a time)
          <div
            ref={carouselRef}
            style={{
              overscrollBehaviorX: "contain", // Contain horizontal scrolling
              touchAction: "pan-x", // Restrict to horizontal swiping
            }}
            onTouchMove={handleTouchMove} // Prevent page scroll
          >
            <Carousel
              showArrows={false}
              showStatus={false}
              infiniteLoop
              showThumbs={false}
              swipeScrollTolerance={50}
              preventMovementUntilSwipeScrollTolerance={true}
              axis="horizontal" // Explicitly enforce horizontal swiping
            >
              {images.map((image, index) => (
                <div key={index}>
                  <img
                    src={image}
                    style={{
                      width: "100%",
                      height: "300px",
                      marginBottom: 50,
                      borderRadius: "8px",
                      touchAction: "pan-x", // Reinforce horizontal swiping
                    }}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        ) : (
          // Slider for larger screens (5 images in a row)
          <Slider {...settings}>
            {images.map((image, index) => (
              <div key={index}>
                <img
                  src={image}
                  alt={`Image ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "300px",
                    borderRadius: "15px",
                    padding: 5,
                    cursor: "pointer",
                  }}
                />
              </div>
            ))}
          </Slider>
        )}
      </Box>

      {/* Section 3: Icons with Descriptions */}
      <Box
        mt={2}
        p={2}
        sx={{ marginBottom: "20px", display: "flex", flexDirection: "column" }}
      >
        <Typography variant="h5" textAlign="center" fontWeight="bold" mb={5}>
          Low Minimums, Quick Turnarounds, Custom Options Inside and Out
        </Typography>
        <Grid container spacing={4} justifyContent="center" mb={2}>
          {/* Top Icons */}
          <Grid item xs={12} sm={4} md={2.5} sx={{ textAlign: "center" }}>
            <IconButton sx={{ fontSize: "40px", marginBottom: "10px" }}>
              <img src="icon1.png" alt="Icon 1" />
            </IconButton>
            <Typography variant="body1" fontWeight="bold">
              Low Minimums and Quick Turnaround
            </Typography>
            <Typography variant="body1">
              36-piece minimum with a 6-7 week turnaround from art approval to
              delivery.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={2.5} sx={{ textAlign: "center" }}>
            <IconButton sx={{ fontSize: "40px", marginBottom: "10px" }}>
              <img src="icon2.png" alt="Icon 2" />
            </IconButton>
            <Typography variant="body1" fontWeight="bold">
              Expert Design Team
            </Typography>
            <Typography variant="body1">
              Work with our veteran headwear specialists, bringing 20+ years of
              industry experience to your custom hat designs.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={2.5} sx={{ textAlign: "center" }}>
            <IconButton sx={{ fontSize: "40px", marginBottom: "10px" }}>
              <img src="icon3.png" alt="Icon 3" />
            </IconButton>
            <Typography variant="body1" fontWeight="bold">
              Fast & Flexible Production
            </Typography>
            <Typography variant="body1">
              In-house fabric stock and exclusive production space.
            </Typography>
          </Grid>
        </Grid>

        {/* Bottom Icons */}
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={4} md={2.5} sx={{ textAlign: "center" }}>
            <IconButton sx={{ fontSize: "40px", marginBottom: "10px" }}>
              <img src="icon4.png" alt="Icon 4" />
            </IconButton>
            <Typography variant="body1" fontWeight="bold">
              Transparent Pricing
            </Typography>
            <Typography variant="body1">
              No hidden fees, flat-rate designs.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={2.5} sx={{ textAlign: "center" }}>
            <IconButton sx={{ fontSize: "40px", marginBottom: "10px" }}>
              <img src="icon5.png" alt="Icon 5" />
            </IconButton>
            <Typography variant="body1" fontWeight="bold">
              Endless Customization
            </Typography>
            <Typography variant="body1">
              HD prints, embroidery, patches, custom snapback colors, inside
              branding.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={2.5} sx={{ textAlign: "center" }}>
            <IconButton sx={{ fontSize: "40px", marginBottom: "10px" }}>
              <img src="icon6.png" alt="Icon 6" />
            </IconButton>
            <Typography variant="body1" fontWeight="bold">
              Premium Materials
            </Typography>
            <Typography variant="body1">
              High-quality fabrics, reinforced stitching, ergonomic fit.
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* {!isMobile && (
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
          backgroundColor="#E8F1FB"
          pb={3}
          mt={3}
        >
          {images.map((image, index) => (
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              key={index}
              container
              justifyContent="center"
            >
              <img
                src={image}
                alt={`Image ${index + 1}`}
                style={{
                  width: "auto",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            </Grid>
          ))}
        </Grid>
      )} */}

      {/* Section 4: Testimonial with Pagination */}
      {/* {!isMobile && (
        <Box
          sx={{
            textAlign: "center",
            backgroundImage: "url('/testimonials.png')",
            backgroundColor: "#193059",
            paddingTop: "50px",
            paddingBottom: "20px",
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ marginBottom: "30px", color: "#fff" }}
          >
            Testimonials
          </Typography>
          <Box>
            <Carousel showThumbs={false} showArrows={false} showStatus={false}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "100px",
                }}
              >
                <Card
                  sx={{
                    maxWidth: 345,
                    margin: "0 15px",
                    backgroundColor: "#E8F1FB",
                    pt: 1,
                    pl: 1,
                    pr: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "300px",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      variant="body1"
                      textAlign="left"
                      sx={{ marginBottom: "20px" }}
                    >
                      I had an amazing experience ordering custom headwear from
                      Banner Day Threads! The quality of their materials is
                      truly premium—comfortable, durable, and built to last. The
                      stitching and print detail were flawless, making my design
                      pop exactly as I envisioned.
                    </Typography>
                    <div style={{ marginTop: "auto" }}>
                      <Typography
                        variant="body2"
                        textAlign="left"
                        color="textSecondary"
                        sx={{ fontStyle: "italic" }}
                      >
                        Alicia Richards
                      </Typography>
                      <Typography
                        variant="body2"
                        textAlign="left"
                        color="textSecondary"
                      >
                        Project Manager
                      </Typography>
                    </div>
                  </CardContent>
                </Card>

                <Card
                  sx={{
                    maxWidth: 345,
                    margin: "0 15px",
                    backgroundColor: "#E8F1FB",
                    pt: 1,
                    pl: 1,
                    pr: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "300px",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      variant="body1"
                      textAlign="left"
                      sx={{ marginBottom: "20px" }}
                    >
                      I really liked the variety of styles and customization
                      options they offer. Whether you need sleek embroidered
                      caps, bold printed designs, or unique fabric choices, they
                      have something for everyone. We will definitely order
                      again.
                    </Typography>
                    <div style={{ marginTop: "auto" }}>
                      <Typography
                        variant="body2"
                        textAlign="left"
                        color="textSecondary"
                        sx={{ fontStyle: "italic" }}
                      >
                        Rebecca Stone
                      </Typography>
                      <Typography
                        variant="body2"
                        textAlign="left"
                        color="textSecondary"
                      >
                        Creative Officer
                      </Typography>
                    </div>
                  </CardContent>
                </Card>

                <Card
                  sx={{
                    maxWidth: 345,
                    margin: "0 15px",
                    backgroundColor: "#E8F1FB",
                    pt: 1,
                    pl: 1,
                    pr: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "300px",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      variant="body1"
                      textAlign="left"
                      sx={{ marginBottom: "20px" }}
                    >
                      What impressed me even more was their quick turnaround.
                      Despite placing a custom order, my hats arrived much
                      faster than expected, without compromising on quality. The
                      customer service team was fantastic, ensuring every detail
                      was perfect before production.
                    </Typography>
                    <div style={{ marginTop: "auto" }}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        textAlign="left"
                        sx={{ fontStyle: "italic" }}
                      >
                        Henry Ramirez
                      </Typography>
                      <Typography
                        variant="body2"
                        textAlign="left"
                        color="textSecondary"
                      >
                        Chief Marketing Officer
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </div>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Card
                  sx={{
                    maxWidth: 345,
                    margin: "0 15px",
                    backgroundColor: "#E8F1FB",
                    pt: 1,
                    pl: 1,
                    pr: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "300px",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      variant="body1"
                      textAlign="left"
                      sx={{ marginBottom: "20px" }}
                    >
                      A fantastic experience, totally satisfied!
                    </Typography>
                    <div style={{ marginTop: "auto" }}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        textAlign="left"
                        sx={{ fontStyle: "italic" }}
                      >
                        Customer 4
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        textAlign="left"
                      >
                        Marketing Director
                      </Typography>
                    </div>
                  </CardContent>
                </Card>

                <Card
                  sx={{
                    maxWidth: 345,
                    margin: "0 15px",
                    backgroundColor: "#E8F1FB",
                    pt: 1,
                    pl: 1,
                    pr: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "300px",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      variant="body1"
                      textAlign="left"
                      sx={{ marginBottom: "80px" }}
                    >
                      Best purchase I have made in a long time!
                    </Typography>
                    <div style={{ marginTop: "auto" }}>
                      <Typography
                        variant="body2"
                        textAlign="left"
                        color="textSecondary"
                        sx={{ fontStyle: "italic" }}
                      >
                        Customer 5
                      </Typography>
                      <Typography
                        variant="body2"
                        textAlign="left"
                        color="textSecondary"
                      >
                        Architect
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </Carousel>
          </Box>
        </Box>
      )} */}
    </Box>
  );
};

export default LandingPage;
